import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Container,
    Content,
    ErrorLink,
    Link,
    SpanLink,
    TextContainer,
    TextError,
    TextSubError,
    Title
} from './styled';
import React, { useState } from 'react';

const ErrorLayout = ({
    children,
    code,
    color,
    description,
    onDismiss = () => null,
    title
}) => {

    const { push } = useHistory();
    const { primaryColor } = useTheme();
    const { t } = useTranslation();
    const [showError, setShowError] = useState(false);
    const parsedColor = color ?? primaryColor;

    const handleDismiss = () => {
        onDismiss();
        push('/');
    };

    return (
        <Container>
            <TextContainer>
                <Title color={ parsedColor }>{ code }</Title>
                <TextError color={ parsedColor }>{ title }</TextError>
                <TextSubError color={ parsedColor }>{ description }</TextSubError>
                {
                    !showError
                        ? <ErrorLink>
                            <SpanLink onClick={ () => setShowError(true) } >
                                { t('Ver detalle de error') }
                            </SpanLink>
                        </ErrorLink>
                        : <>
                            <Content>
                                { children }
                            </Content>
                            <ErrorLink isOpen={ showError } >
                                <SpanLink onClick={ () => setShowError(false) } >
                                    { t('Mostrar menos') }
                                </SpanLink>
                            </ErrorLink>
                        </>
                }
                <Link isOpen={ showError } onClick={ handleDismiss }>
                    { t('Volver al inicio') }
                </Link>
            </TextContainer>
        </Container>
    );
};

ErrorLayout.propTypes = {
    children: PropTypes.any,
    code: PropTypes.string,
    color: PropTypes.string,
    description: PropTypes.string,
    onDismiss: PropTypes.func,
    title: PropTypes.string
};

export default ErrorLayout;
